module.exports = __webpack_public_path__ + "static/media/clientPhoto1.563a8aab.png";